// @flow

import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Site } from "tabler-react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { findNotifications, patchNotification, patchNotifications } from '../actions';
import Auth from '../auth/auth';
import * as moment from 'moment';
import * as signalR from '@aspnet/signalr';
import { toastr } from 'react-redux-toastr';
import ReduxToastr from 'react-redux-toastr';

const auth = new Auth({});

let navBarItems = [
  { value: "Home", to: "/", icon: "home", LinkComponent: NavLink }
  // {
  //   value: "Components",
  //   icon: "calendar",
  //   subItems: [
  //     { value: "Maps", to: "/maps", LinkComponent: NavLink },
  //     { value: "Icons", to: "/icons", LinkComponent: NavLink },
  //     { value: "Store", to: "/store", LinkComponent: NavLink },
  //     { value: "Blog", to: "/blog", LinkComponent: NavLink },
  //   ],
  // }
];

if ((auth.hasAccess('request', 'read') || auth.hasAccess('request', 'admin')) && auth.validateIntranet('request')) {
  let subItems = [];
  if (auth.hasAccess('request', 'admin')) {
    subItems.push({ value: 'All Requests', to: '/requisition/all', LinkComponent: NavLink });
  }
  subItems.push({ value: 'My Requests', to: '/requisition/mine', LinkComponent: NavLink });
  subItems.push({ value: 'Assigned To Me', to: '/requisition/assigned', LinkComponent: NavLink });
  subItems.push({ value: 'View Only', to: '/requisition/view-only', LinkComponent: NavLink });
  subItems.push({ value: 'Report', to: '/requisition/report', LinkComponent: NavLink });

  navBarItems.push({
    value: "Requisition",
    icon: "git-pull-request",
    subItems: subItems
  });
}

if (auth.hasAccess('user', 'read') && auth.validateIntranet('user')) {
  navBarItems.push({
    value: "Users",
    icon: "user",
    to: "/users",
    LinkComponent: NavLink
  });
}

if (auth.hasAccess('role', 'read') && auth.validateIntranet('role')) {
  navBarItems.push({
    value: "Roles",
    icon: "check-circle",
    to: "/roles",
    LinkComponent: NavLink
  });
}

if (auth.hasAccess('department', 'read') && auth.validateIntranet('department')) {
  navBarItems.push({
    value: "Departments",
    icon: "grid",
    to: "/departments",
    LinkComponent: NavLink
  });
}

// const notificationsObjects = [
//   {
//     avatarURL: "demo/faces/male/41.jpg",
//     message: (
//       <React.Fragment>
//         <strong>Nathan</strong> pushed new commit: Fix page load performance
//         issue.
//       </React.Fragment>
//     ),
//     time: "10 minutes ago",
//   },
//   {
//     avatarURL: "demo/faces/female/1.jpg",
//     message: (
//       <React.Fragment>
//         <strong>Alice</strong> started new task: Tabler UI design.
//       </React.Fragment>
//     ),
//     time: "1 hour ago",
//   },
//   {
//     avatarURL: "demo/faces/female/18.jpg",
//     message: (
//       <React.Fragment>
//         <strong>Rose</strong> deployed new version of NodeJS REST Api // V3
//       </React.Fragment>
//     ),
//     time: "2 hours ago",
//   },
// ];

const accountDropdownProps = {
  avatarURL: `https://ui-avatars.com/api/?name=${auth.name}&background=467fcf&color=fff`,
  name: auth.name,
  description: '',
  options: [
    // { icon: "user", value: "Profile" },
    // { icon: "settings", value: "Settings" },
    // { icon: "mail", value: "Inbox", badge: "6" },
    // { icon: "send", value: "Message" },
    // { isDivider: true },
    // { icon: "help-circle", value: "Need help?" },
    { icon: "log-out", value: "Sign out", to: '/logout' },
  ],
};

class SiteWrapper extends Component {

  constructor(props) {
    super(props);

    this.state = {
      notifications: []
    };

  }

  componentDidMount() {
    this.props.findNotifications(1, 30, null, null, null, null, auth.name);
    let connection = new signalR.HubConnectionBuilder().withUrl(`${process.env.REACT_APP_ERP_HUB_HOST}/notifications?userName=${auth.name}`).build();
    connection.on("ReceiveMessage", data => {
      toastr.light(data.name, data.content, {
        timeOut: 0,
        onToastrClick: () => this.readNotification(data),
        icon: 'info',
        status: 'info',
        component: (
          <div>
            <small className="text-muted">{moment(data.createdOn).format('DD/MM/YYYY hh:mm a')}</small>
          </div>
        )
      });
      this.props.findNotifications(1, 30, null, null, null, null, auth.name);
    });
    connection.start();
  }

  readNotification(i) {
    console.log('readNotification' ,i);
    if (i.read) {
        window.location.href = i.url;
        return;
    }
    var notification = {
      id: i.id,
      patchData: [ {
        value: true,
        path: '/read',
        op: 'replace',
      }]
    };
    this.props.patchNotification(notification, (response) => {
      console.log('readNotification', 'patchNotification', response);
      this.props.findNotifications(1, 30, null, null, null, null, auth.name);
      window.location.href = i.url;
    }, (error) => {
      console.log('patchNotification', error);
    });
  }

  readAllNotifications() {
    const { notifications } = this.props;
    console.log('readAllNotifications', notifications);

    const data = notifications.items
      .filter(n => !n.read)
      .map(n => {
        return {
          id: n.id,
          patchData: [
            {
              value: true,
              path: '/read',
              op: 'replace',
            }
          ]
        };
      });

    this.props.patchNotifications(data, response => {
      console.log('readNotifications', 'patchNotifications', response);
      this.props.findNotifications(1, 30, null, null, null, null, auth.name);
    });

  }

  render() {

    let notificationsObjects = [];

    if (this.props.notifications && this.props.notifications.items) {
      for(let i of this.props.notifications.items) {
        notificationsObjects.push({
          avatarURL: `https://ui-avatars.com/api/?name=${i.createdBy}&background=${i.read ? '5eba00' : 'cd201f'}&color=fff`,
          message: (
            <div onClick={() => this.readNotification(i)}>
              <React.Fragment>
                <strong className="cursor-pointer text-primary">{i.name}</strong>
                <br />
                {i.content}
              </React.Fragment>
            </div>
          ),
          time: <div>
            <span className={`notification-${i.read ? 'read': 'unread'}`}></span>
            <small className="muted ml-1">{i.read ? 'read': 'unread'}</small>
            <span>, {moment(i.createdOn).from(moment())}</span>
          </div>,
          read: i.read
        });
      }
    }

    const unread = notificationsObjects.length > 0 && notificationsObjects.filter(f => !f.read).length > 0;

    return (
      <Site.Wrapper
        headerProps={{
          href: "/",
          alt: "Kiat Lee Landscape and Building",
          imageURL: "/assets/brand/logo.png",
          navItems: "",
          notificationsTray: {
            notificationsObjects,
            unread,
            markAllAsRead: this.readAllNotifications.bind(this)
          },
          accountDropdown: accountDropdownProps,
        }}
        navProps={{ itemsObjects: navBarItems }}
        footerProps={{
          links: [
          ],
          note:
            "",
          copyright: (
            <React.Fragment>
              Copyright © {  new Date().getFullYear() }
              <a href="."> Kiat Lee Landscape and Building</a>.
              All rights reserved.
            </React.Fragment>
          ),
          nav: "",
        }}
      >
        {this.props.children}
        <ReduxToastr
          preventDuplicates
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          closeOnToastrClick/>
      </Site.Wrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ findNotifications, patchNotification, patchNotifications }, dispatch);
}

function mapStateToProps(props) {
  return {
    notifications: props.notifications.notifications
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteWrapper);



// WEBPACK FOOTER //
// ./src/common/sitewrapper.react.js